import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { DateTitle } from "./Components";

const RecruitRow = ({ title, id, uuid, addressLevel2, addressLevel3, time, school, category }) => (
  <>
    <div className="card border-0 p-3 user-radius mb-2 mt-2">
      <div className="row">
        <div className="col">
          <div className="pull-left">
            <strong>{title}</strong>
          </div>
          <div className="pull-right">
            <a href={`#/校园招聘/${id}?u_id=${uuid}`}>
              详情
              <FontAwesomeIcon icon={faAngleRight} fixedWidth size="lg" />
            </a>
          </div>
          <br />
          <span className="text-muted" style={{ fontSize: 11 }}>
            举办地点:
            {`${addressLevel2}-${addressLevel3}`}
            <br />
            开始时间:{time}
          </span>
          <br />
          <span>
            {school}({category})
          </span>
        </div>
      </div>
    </div>
  </>
);

RecruitRow.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  addressLevel2: PropTypes.string.isRequired,
  addressLevel3: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  school: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
};

const Schedule = () => {
  const [list, setList] = useState({});

  const [auth, setAuth] = useState(0);

  const [flag, setFlag] = useState(false);

  useEffect(() => {
    const _auth = JSON.parse(localStorage.getItem("auth"));
    if (_auth !== null) {
      setAuth(_auth);
      fetch(`/gin-api/candidate-schedule?option=filterBy-refId&refId=${_auth.id}`)
        .then((res) => res.json())
        .then((res) => {
          const url = [
            "/gin-api/campus",
            "?option=filterBy-ids",
            `&ids=${res.map((c) => c.ref1Id).join(",")}`,
          ];
          fetch(url.join(""))
            .then((response) => {
              if (response.status < 400) return response.json();
              throw new Error("请求数据失败");
            })
            .then((data) => {
              const _data = {};
              const today = moment().format("YYYY-MM-DD");
              if (data) {
                data.forEach((item) => {
                  let { date } = item;
                  if (today === date) {
                    date = "今天";
                  }
                  if (_data[date]) {
                    _data[date].push(item);
                  } else {
                    _data[date] = [item];
                  }
                });
              }
              if (JSON.stringify(_data) === "{}") {
                setFlag(true);
              } else {
                setList(_data);
              }
            });
        });
    }
  }, []);

  const handleLogIn = async () => {
    location.href = "#/登录?id=1";
  };

  return (
    <>
      {auth === 0 ? (
        <div className="container-fluid">
          <div className="chat-login">
            <h6>登录后可以查看日程</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ fontSize: 14 }}>
          <div className="tab-content mt-1">
            <div className="tab-pane fade show active">
              {flag === true ? (
                <div className="chat-login">
                  <h6>您近期还没有新的日程</h6>
                </div>
              ) : (
                <div>
                  {Object.getOwnPropertyNames(list).map((key) => (
                    <React.Fragment key={key}>
                      <DateTitle text={key} />
                      <div className="mt-2" />
                      {list[key].map((item) => (
                        <RecruitRow key={item.id} {...item} />
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <Navbar category="我的" />
    </>
  );
};

export default Schedule;
